<div fxLayout="row" class="mobile-top">

  <div fxFlex="120px" fxLayoutAlign="start center">
    <img alt="Logo" class="logo" src="./assets/img/brand/{{brand}}/logo.png">
  </div>

  <div fxFlex="calc(100%-140px)" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">

    <kendo-appbar-section>
      <button #menuAnchor kendoButton fillMode="flat" icon="menu" (click)="togglePopupMenu()"> </button>
    </kendo-appbar-section>

    <kendo-popup [anchor]="menuAnchor.element" *ngIf="showPopupMenu" [margin]="margin">
      <div class="content">
        <div *ngIf="canMakeBusinessTripsFromMobile">
          <a class="navigation-tabs__link" routerLink="mobileCenter/businessTrips"> {{'layout.topToolbarBusinessTrips' | translate}}</a>
        </div>
        <div>
          <a class="navigation-tabs__link" routerLink="mobileCenter"> {{'layout.topToolbarHomePage' | translate}}</a>
        </div>
      </div>
    </kendo-popup>

    <kendo-icon class="pointer k-icon-md" [routerLink]="['/mobileCenter/']" name="home"></kendo-icon>

    <app-portal-switcher 
      [allowMainPortal]="true" 
      [allowMobilePortal]="false" 
      [allowWorkshopPortal]="true"
      [allowDealerPortal]="true"
      [allowPartsSupplierPortal]="true">
      </app-portal-switcher>

    <div fxLayout="column">
      <kendo-icon class="k-icon-md" name="user"></kendo-icon>
      <span class="user-name"> {{user.userData.userName}}</span>
    </div>

    <kendo-appbar-section>
      <app-user-portal-messages-indicator
        [messageServicingUrl]="'/mobileCenter/messages'"></app-user-portal-messages-indicator>
    </kendo-appbar-section>

    <app-select-localization></app-select-localization>

    <kendo-icon class="pointer k-icon-md" name="logout" (click)="logoutUser()"></kendo-icon>

  </div>

</div>

<div *ngIf="isTrainingEnv">
  <span class="env-display-name">{{'global.testEnvInfoName' | translate}}</span>
</div>
<router-outlet></router-outlet>